import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { ServerCachedUser } from '@adornis/bh-util/util.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { mongo } from '../server/mongo.js';

@Entity()
export class ActionTokenData extends MongoEntity {
  static override _class = 'ActionTokenData';
  static override _collectionName = 'action-token-datas';

  @validate(nonOptional())
  @Field(type => String)
  userID!: string;

  @validate(nonOptional())
  @Field(type => String)
  action!: string;

  @validate(nonOptional())
  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean, { default: v => v ?? true })
  isValid!: boolean;

  static async getAllowedActionTokenData(user: ServerCachedUser) {
    const aggregation = [
      { $match: { userID: user._id } }, //
      { $group: { _id: null, ids: { $push: '$_id' } } },
    ];

    const actionTokenDataCollection = mongo().collection(ActionTokenData._collectionName);
    const result = await actionTokenDataCollection.aggregate(aggregation).toArray();
    return result.at(0)?.ids ?? [];
  }
}
